import { useContext } from 'react';
import { PrimaryButton } from '@/common/Button';
import ModalContext from '~/context/vdp/ModalContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import {
  ButtonWrapper,
  Contents,
  FireIcon,
  MonthlyDetails,
  MonthlyPayment,
  PayMonthlyCopy,
  PriceSection,
  Title
} from './Card.styles';
import CommonCard from './CommonCard';
import usePaymentSummary from '../../hooks/selectors/useGetPaymentSummary';
import roundRateToPercent from '../../utils/roundRateToPercent';

function PayMonthlyCard() {
  const { setSoftPullModalOpen } = useContext(ModalContext);
  const { vdpPricingInfo } = useContext(UserVehicleContext);
  const {
    financing: { apr, monthlyPayment, term }
  } = usePaymentSummary();

  const handleCTAClick = () => {
    setSoftPullModalOpen(true);
  };

  return (
    <CommonCard isLoading={vdpPricingInfo.isLoading}>
      <Title>Pay Monthly</Title>
      <Contents>
        <PriceSection>
          <MonthlyPayment>${monthlyPayment}</MonthlyPayment>
          <span className="text-blue-6 tl-body-m">/mo*</span>
          <div className="mx-auto mt-8 max-w-[250px] text-center text-grey-5 tl-body-xs">
            *Estimated payment based on a {roundRateToPercent(apr)}% APR for{' '}
            {term} months and a $10/mo auto pay discount
          </div>
        </PriceSection>
        <MonthlyDetails>
          <PayMonthlyCopy>
            No hit to your credit, see real monthly payments while shopping.
          </PayMonthlyCopy>
          <div className="flex items-center text-nowrap text-grey-5 tl-body-s m:mb-0">
            <FireIcon />
            Roughly 80% of customers finance with us
          </div>
        </MonthlyDetails>
        <ButtonWrapper className="mt-24 m:mt-28">
          <PrimaryButton
            className="w-full"
            onClick={handleCTAClick}
            data-analytics-id={null}
            size="medium"
          >
            Get Your Terms
          </PrimaryButton>
        </ButtonWrapper>
      </Contents>
    </CommonCard>
  );
}

export default PayMonthlyCard;
